import * as React from 'react';

import styled, { css } from 'styled-components';

import { InputDecorationType } from '../input-decoration';

interface StyledLabelProps {
  className?: string;
  id?: string;
  label: React.ReactNode;
  active?: boolean;
  withDecoration?: InputDecorationType;
  bigDecoration?: boolean;
  biggerDecoration?: boolean;
  alignRight?: boolean;
  small?: boolean;
  isDark?: boolean;
}

const labelMoved = (withDecoration?: InputDecorationType) => {
  return withDecoration === 'left' || withDecoration === 'both';
};

const isActiveCss = css`
  top: 7px;
  font-size: ${({ theme }) => theme.typography.span};
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.colors.inputLabel};

  @media ${({ theme }) => theme.device.tablet} {
    top: 12px;
  }
`;

const isNotActiveCss = css`
  top: 15px;
  font-size: ${({ theme }) => theme.typography.span};
  font-weight: 700;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.secondaryDark};

  @media ${({ theme }) => theme.device.tablet} {
    font-size: ${({ theme }) => theme.typography.h4};
    top: 19px;
  }
`;

const StyledLabel = styled((props: StyledLabelProps) => (
  <label htmlFor={props.id} className={props.className}>
    {props.label}
  </label>
))`
  position: absolute;
  left: ${(props) =>
    labelMoved(props.withDecoration)
      ? props.bigDecoration
        ? '48px'
        : '34px'
      : '9px'};
  ${(props) => (props.biggerDecoration ? 'left: 128px' : null)};
  opacity: 1;
  pointer-events: none;
  transition: top
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  @media ${({ theme }) => theme.device.tablet} {
    left: ${(props) =>
      labelMoved(props.withDecoration)
        ? props.bigDecoration
          ? '64px'
          : '45px'
        : '15px'};

    ${(props) =>
      props.biggerDecoration
        ? css`
            left: 144px;
          `
        : null};
  }

  ${(props) =>
    props.alignRight
      ? css`
          left: auto;
          right: 12px;

          @media ${({ theme }) => theme.device.tablet} {
            left: auto;
            right: 18px;
          }
        `
      : null}

  ${(props) =>
    props.isDark
      ? css`
          color: ${({ theme }) => theme.colors.white};
        `
      : null}

  ${(props) => (props.active ? isActiveCss : isNotActiveCss)}
  ${(props) =>
    props.small
      ? props.active
        ? css`
            top: 7px;
            @media ${({ theme }) => theme.device.tablet} {
              top: 10px;
            }
          `
        : css`
            top: 12px;
            @media ${({ theme }) => theme.device.tablet} {
              top: 14px;
            }
          `
      : ''}
`;

export default StyledLabel;
